/**
 * Stable CSS class names for E2E — Order not finance page.
 */
export const ONF = {
    root: 'order-not-finance-page',
    searchGrid: 'order-not-finance-page__search-grid',
    inputWithButtonPaper: 'order-not-finance-page__orders-id-paper',
    inputOrdersId: 'order-not-finance-page-input--text-orders-id',
    inputSendButton: 'order-not-finance-page-input--button-send-orders-id',
    sendTextButton: 'order-not-finance-page-input--button-send',
    batchSearchButton: 'order-not-finance-page-input--button-batch-search',
    modalTriggerWrap: 'order-not-finance-page__modal-trigger-wrap',
} as const;

